import { useEffect, useState } from "react";
import { serverFetch } from "@server";
import { Button, message, Popconfirm, Space, Table } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { tokenVids } from "@extensions/enums";
import MessagesToken from "./messages-token";

const MessagesTokens = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [providers, setProviders] = useState([]);
  const [spaces, setSpaces] = useState([]);

  const getData = () => {
    setLoading(true);
    serverFetch("token?internalOnly=false")
      .then(data => { setLoading(false); setItems(data); })
      .catch(e => { setLoading(false); message.error(e.userMessage || "Ошибка загрузки"); });
  };

  const getProviders = () => {
    serverFetch("token/Providers")
      .then(data => setProviders(data))
      .catch(e => message.error(e.userMessage || "Ошибка загрузки провайдеров"));
  };

  const getSpaces = () => {
    serverFetch("Cyber/spaces")
      .then(data => setSpaces(Array.isArray(data) ? data : []))
      .catch(() => setSpaces([]));
  };

  useEffect(() => {
    getData();
    getProviders();
    getSpaces();
  }, []);

  const handleAdd = () => {
    setSelected(0);
  };

  const handleDelete = (tokenId) => {
    setLoading(true);
    serverFetch(`token/${tokenId}`, { method: "DELETE" })
      .then(() => { message.success("Токен удален"); getData(); })
      .catch(e => { setLoading(false); message.error(e.userMessage || "Ошибка при удалении"); });
  };

  const handleSuccess = () => {
    message.success(selected === 0 ? "Канал добавлен" : "Канал обновлен");
    getData();
  };

  const columns = [
    {
      title: "",
      width: 70,
      render: (_, record) => (
        <div className="actions-on-hover" style={{ display: "flex", gap: 4 }}>
          <Button type="text" size="small" icon={<EditOutlined />} onClick={() => setSelected(record.id)} />
          <Popconfirm title="Подтверждение удаления" description="Вы уверены, что хотите удалить этот канал?" onConfirm={() => handleDelete(record.id)} okText="Удалить" cancelText="Отмена">
            <Button type="text" size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </div>
      ),
    },
    { dataIndex: "id", title: "#", width: 80 },
    { dataIndex: "idx", title: "Порядок", width: 100 },
    { dataIndex: "name", title: "Наименование", width: 200 },
    { dataIndex: "code", title: "Код", width: 300 },
    { dataIndex: "vid", title: "Вид", width: 120, render: (value) => tokenVids.find(t => t.value === value)?.label },
    { dataIndex: "spaceId", title: "Киберменеджер", width: 200, render: (value) => (value != null ? spaces.find(s => s.id === value)?.name ?? value : "-") },
    { dataIndex: "provider", title: "Провайдер", width: 150, render: (value) => value ? providers.find(p => p.id === value)?.name || value : "-" },
    { dataIndex: "active", title: "Активен", width: 100, render: (value) => value ? "Да" : "Нет" },
  ];

  return <>
    <Space style={{ marginBottom: 16 }}>
      <Button type="primary" onClick={handleAdd} disabled={loading}>Добавить</Button>
      <Button onClick={getData}>Обновить</Button>
    </Space>
    <Table columns={columns} dataSource={items} loading={loading} rowKey="id" size="small" scroll={{ x: 'max-content' }} pagination={false} />
    {selected !== null && <MessagesToken onClose={() => setSelected(null)} onSuccess={handleSuccess} id={selected} providers={providers} spaces={spaces} />}
  </>;
};

export default MessagesTokens;
